import { USER_PROFILE_PAGE_HEADER_FOOTER_ACTION } from '../../UserProfilePageHeaderFooter.constants'

export const USER_PROFILE_PAGE_STATUS_ACTIONS_CONFIRMATION = {
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]: {
    descriptionKey: 'Modal.InhabitantApproveConfirmationTextKey',
    submitTextKey: 'Modal.InhabitantApproveBtnKey',
  },
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive]: {
    descriptionKey: 'Modal.InhabitantArchiveConfirmationTextKey',
    submitTextKey: 'Modal.InhabitantArchiveBtnKey',
  },
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.block]: {
    descriptionKey: 'Modal.InhabitantBlockConfirmationTextKey',
    submitTextKey: 'Modal.InhabitantBlockBtnKey',
  },
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore]: {
    descriptionKey: 'Modal.InhabitantRestoreConfirmationTextKey',
    submitTextKey: 'Modal.InhabitantRestoreBtnKey',
  },
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.unblock]: {
    descriptionKey: 'Modal.InhabitantUnblockConfirmationTextKey',
    submitTextKey: 'Modal.InhabitantUnblockBtnKey',
  },
}

export const QA_NAME_USER_PROFILE_PAGE_STATUS_ACTION_CONFIRMATION =
  'confirmation'
